import serverData from '../server-data'
import { HEADER_TYPES } from '../../constants'
import {
  contentStylesForGuest,
  contentStylesV1ForGuest,
  contentStyles,
  contentStylesV1,
} from '../../screens/groupdetail/index.css'
import { isDetailsV1Dot1Enabled } from '../features'

export function getContentStyles() {
  const isNewDetailsUI = isDetailsV1Dot1Enabled()
  if (serverData.headerType === HEADER_TYPES.GUEST) {
    return isNewDetailsUI ? contentStylesV1ForGuest : contentStylesForGuest
  }

  return isNewDetailsUI ? contentStylesV1 : contentStyles
}
